import { isOwnerOrSupport } from 'shared/helpers/matchers/checkUserType';

const requestHedgeDateAccess = ({ userType, relatedCompany, withoutCompanyValidation = false }) =>
  (isOwnerOrSupport(userType) && withoutCompanyValidation) || relatedCompany?.materialCountRequired;

export { requestHedgeDateAccess };
